import { render } from "./ListSquad.vue?vue&type=template&id=3ffec598&scoped=true"
import script from "./ListSquad.vue?vue&type=script&lang=js"
export * from "./ListSquad.vue?vue&type=script&lang=js"

import "./ListSquad.vue?vue&type=style&index=0&id=3ffec598&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffec598"]])

export default __exports__